import {
  string as yupString,
  number as yupNumber,
} from 'yup';

import InputFormik from '../../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../../shared/forms/select/sdkSelectFormik.component';
import { maxLength, required } from '../../../shared/forms/validators';
import EditCurrencyCodeModalAlert from './editCurrencyCodeModalAlert.component';

const schema = [
  {
    name: 'editCurrencyCodeWarning',
    component: EditCurrencyCodeModalAlert,
    options: { readOnly: true },
  },
  {
    name: 'currencyCode',
    component: InputFormik,
    meta: { label: 'Currency Code' },
    options: { yupType: yupString(), disabledWhenEditing: true, validationRules: [required, maxLength(3)] },
    additionalProps: { required: true },
  },
  {
    name: 'enabledFlag',
    component: SelectFormik,
    meta: { label: 'Enabled Flag', optionsKey: 'enabledFlagOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'precision',
    component: InputFormik,
    meta: { label: 'Precision' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true },
  },
];

export default schema;
